// @ts-nocheck
import React from 'react';
import { i18n } from 'config/locales';
import SvgComponent from 'components/Form/SvgComponent';
import './index.scss';

export class CreditFreezeBanner extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      disabled: false,
    };

    this.dismissButton = React.createRef();
    this.dismissBanner = this.dismissBanner.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentSubsectionKey !== this.props.currentSubsectionKey
      && (this.props.currentSubsectionKey === "IDENTIFICATION_INTRO"
        || this.props.currentSubsectionKey === "REVIEW_AND_SUBMIT_SUBMIT")) {
      this.setState({ disabled: false, });
    }
  }

  dismissBanner() {
    this.setState({ disabled: true, });
  }

  render() {
    return (
      <>{this.state.disabled !== true && (
        <div className="usa-alert usa-alert-warning credit-freeze-banner">
          <div className="credit-freeze-banner__wrapper">
            <p className="usa-alert-text credit-freeze-banner__text">
              {i18n.t('review.creditFreezeMessage')}
              &nbsp;
              <a
                href="https://www.opm.gov/suitability/suitea-notice-24-01.pdf"
                target="_blank"
                className="hyperlink"
                rel="noopener noreferrer"
              >
                {i18n.t('app.creditFreeze')}
              </a>
            </p>
            <div className={'toggle-icon xmark'}>
              <button
                type="button"
                className="toggle-icon xmark"
                onClick={this.dismissBanner}
                ref={this.dismissButton}
              >
                <SvgComponent className={'toggle-icon xmark'} src={'/img/xmark.svg'} />
              </button>
            </div>
          </div>
        </div>
      )}</>
    );
  }
}

CreditFreezeBanner.defaultProps = {
  currentSubsectionKey: '',
};

export default CreditFreezeBanner;
